
import list from '@/mixins/list'
import hasPageMeta from '@/mixins/hasPageMeta'
import { mapState, mapGetters } from 'vuex'

export default {
    mixins: [list, hasPageMeta],

    props: {
        file: {
            type: String,
            required: true,
        },
        typeId: {
            type: [String, Number],
            default: undefined,
        },
        typeSlug: {
            type: String,
            default: undefined,
        },
    },

    data() {
        return {
            listApi: `/api/v1/search-content-type/${this.typeId}`,
            listFilters: [],
            isVendorManagerSession: false,
            defaultSortingOptions: [
                {
                    id: 'latest',
                    name: "Newest Editors' Picks",
                    key: 'order',
                    dir: 'desc',
                },
                {
                    id: 'oldest',
                    name: 'Oldest first',
                    key: 'order',
                    dir: 'asc',
                },
                {
                    id: 'A-Z',
                    name: 'A-Z',
                    key: 'name',
                    dir: 'asc',
                },
                {
                    id: 'Z-A',
                    name: 'Z-A',
                    key: 'name',
                    dir: 'desc',
                },
            ],
        }
    },

    computed: {
        ...mapState({
            jsonData: (state) => state.jsonloader.data || {},
            taxonomies: (state) => state.data.taxonomies || [],
            contentTypes: (state) => state.data.contentTypes || [],
            user: (state) => state.auth.user || {},
        }),

        content() {
            return this.jsonData[this.file] || {}
        },

        sortOpts() {
            return this.content?.sort || this.defaultSortingOptions
        },

        heroContent() {
            return this.content?.hero || {}
        },

        metaContent() {
            return this.content?.meta || {}
        },

        routesContent() {
            return this.content?.routes || {}
        },

        siteTitle() {
            return `${
                this.selectedTaxonomy && this.selectedTaxonomy.metas && this.selectedTaxonomy.metas.meta_title
                    ? this.selectedTaxonomy.metas.meta_title
                    : this.metaContent?.title || undefined
            }`
        },

        heroTitle() {
            if (!this.isHomePage && this.isBrandsPage) return 'Shop by Brand'
            else if (!this.isHomePage && this.$route.query?.q && this.content?.taxonomy?.results_text)
                return this.content.taxonomy.results_text.replace('%s', this.$route.query.q)
            else if (!this.isHomePage && this.currentTag && this.content?.taxonomy?.results_text)
                return this.content.taxonomy.results_text.replace('%s', this.currentTag)
            return this.selectedTaxonomy?.name || this.heroContent?.name || undefined
        },

        heroBack() {
            return this.content?.backLink
            // if (this.parentTaxonomy) return { name: this.taxonomyRoute, params: { taxonomy: this.parentTaxonomy.slug, taxonomyid: this.typeSlug } }
            // else if (this.taxonomy && this.routesContent.base && this.heroContent.back) return { name: this.routesContent.base }
            // else return undefined
        },

        siteDescription() {
            return this.selectedTaxonomy?.metas?.meta_description || this.metaContent?.excerpt || undefined
        },

        heroExcerpt() {
            return this.selectedTaxonomy?.excerpt || this.heroContent?.excerpt || undefined
        },

        previewImage() {
            return this.selectedTaxonomy?.cover?.url || this.metaContent?.image || undefined
        },

        allTaxonomyList() {
            return this.taxonomyKey && this.taxonomies[this.taxonomyKey]
                ? this.taxonomies[this.taxonomyKey].reduce((acc, el) => {
                      if (el && el.children) acc = acc.concat(this.getChildren(el))
                      acc.push(el)
                      return acc
                  }, [])
                : []
        },

        taxonomyKey() {
            return this.typeSlug || this.content?.taxonomy?.key
        },

        currentTag() {
            return this.$route.query?.tag || undefined
        },

        isBrandsPage() {
            return this.$route.name === 'shop-brands'
        },

        taxonomyList() {
            return this.selectedTaxonomy?.id ? this.selectedTaxonomy.children || [] : this.taxonomies[this.taxonomyKey]
        },

        taxonomyRoute() {
            if (this.typeSlug && this.routesContent?.base) return `${this.routesContent.base}-taxonomy-taxonomyid-taxonomy`
            return this.routesContent?.taxonomy || undefined
        },

        contentTypeList() {
            const contentTypes = this.contentTypes.find((el) => el.id === this.typeId)?.children
            return contentTypes?.length ? contentTypes.filter((el) => !el.is_hidden) : []
        },

        selectedTaxonomy() {
            return this.taxonomyKey
                ? this.allTaxonomyList.find((el) => el.slug === this.taxonomy)
                : this.contentTypes
                      .reduce((acc, el) => {
                          acc.push(el)
                          if (el.children.length) acc = [...acc, ...el.children]
                          return acc
                      }, [])
                      .find((el) => el.slug === this.taxonomy)
        },

        parentTaxonomy() {
            return this.allTaxonomyList.find((el) => (el.children?.length ? el.children.findIndex((c) => c.slug === this.taxonomy) !== -1 : false)) || null
        },

        taxonomy() {
            return this.$route.params?.taxonomy
        },

        currentSortingOption() {
            return this.defaultSortingOptions.find((el) => el.id === this.$route.query['sort']) || this.sortOpts[0]
        },

        customParams() {
            const obj = {}
            if (this.taxonomyKey) obj[`taxonomy_${this.taxonomyKey}`] = this.taxonomy || undefined
            if (this.currentTag) obj[`tag_${this.currentTag}`] = 1
            if (this.$route.query.sort) {
                obj['order-by'] = this.currentSortingOption.key || 'order'
                obj['order-dir'] = this.currentSortingOption.dir || 'desc'
            } else {
                obj['order-by'] = this.content?.order?.key || 'order'
                obj['order-dir'] = this.content?.order?.dir || 'desc'
            }
            return {
                ...obj,
                'meta-key': this.$route.query['meta-key'] || undefined,
                'meta-val': this.$route.query['meta-val'] || undefined,
            }
        },
        
        isArticle() {
            return this.cardComponent === 'loverly-v2-content-item-article'
        },

        cardComponent() {
            const val = this.content.taxonomy?.card || undefined
            if (this.isBrandsPage) return 'loverly-v2-content-item-brand'
            switch (val) {
                case 'vendor-item':
                    return 'loverly-v2-content-item-vendor'
                case 'real-wedding-item':
                    return 'loverly-v2-content-item-real-wedding'
                case 'video-item':
                    return 'loverly-v2-content-item-video'
                case 'product-item':
                    return 'loverly-v2-content-item-product'
                case 'shop':
                    return 'loverly-v2-content-item-product'
                default:
                    return 'loverly-v2-content-item-article'
            }
        },

        showVendorManagerLink() {
            return this.isVendorManagerSession && this.content?.routes?.base === 'vendors'
        },

        isHomePage() {
            if (this.isBrandsPage) return false
            if (this.currentTag) return false
            if (this.taxonomy) return false
            if (Object.keys(this.$route.query).length > 0) {
                if (this.$route.query.q) return false
                const metaKeys = Object.keys(this.$route.query).filter((el) => el.includes('meta-'))
                if (metaKeys.length > 0) return false
                if (this.$route.query.locations) return false
                if (this.$route.query.settings) return false
            }
            return true
        },

        filterKeys() {
            return (this.content?.filters || []).map((i) => i.key)
        },

        hasFilters() {
            if (this.currentTag) return true
            let hasFilters = false
            this.filterKeys.forEach((key) => {
                if (key !== 'q' && this.$route.query[key]) hasFilters = true
            })
            return hasFilters
        },
        taxonomyFilter() {
            return !!(this.content && this.content.taxonomy && this.content.taxonomy.key)
        },
        typeFilter() {
            return !!(this.content && this.content.taxonomy && !this.content.taxonomy.key)
        },
        filterList() {
            if (this.taxonomyFilter) return this.taxonomyList
            else if (this.typeFilter) return this.contentTypeList
            return []
        },
        savedLink() {
            switch (this.contentType) {
                case 'shop':
                    if (this.isBrandsPage) return { name: 'tools-vendor-manager' }
                    else return { name: 'users-username-slug', params: { username: this.user.username, slug: 'products' } }
                case 'vendors':
                    return { name: 'tools-vendor-manager' }
                case 'real-weddings':
                    return { name: 'users-username-slug', params: { username: this.user.username, slug: 'real-weddings' } }
                case 'planning':
                    return { name: 'users-username-slug', params: { username: this.user.username, slug: 'articles' } }
                default:
                    return { name: 'users-username-slug', params: { username: this.user.username, slug: 'boards' } }
            }
        },
    },

    created() {
        this.$fetch()
    },

    mounted() {
        this.$store.dispatch('layout/setHeader', { title: this.heroTitle, to: this.heroBack })
        this.isVendorManagerSession = this.$cookies.get('is-vendor-manager-session') || false
    },

    methods: {
        getTaxonomyImage(model) {
            try {
                if (model?.metas?.card_image) {
                    const a = JSON.parse(model.metas.card_image)
                    if (a && a.id) return `${process.env.apiUrl}/api/v1/attachments/64/64/${a.id}`
                }
            } catch (e) {}
            return '/whimsical.png'
        },

        getContentTypeImage(model) {
            return model?.list_image?.url || '/whimsical.png'
        },

        getChildren(parent) {
            if (parent && parent.children && parent.children.length) {
                return parent.children.reduce((acc, el) => {
                    acc.push(el)
                    if (el.children && el.children.length) acc = acc.concat(this.getChildren(el))
                    return acc
                }, [])
            }
            return []
        },

        clearFilters() {
            if (!this.hasFilters) return
            const query = JSON.parse(JSON.stringify(this.$route.query))
            this.filterKeys.forEach((key) => {
                if (key !== 'q') delete query[key]
            })
            this.$router.replace({ query })
        },
    },
}
